import React from "react"

import { Redirect, withRouter } from "react-router-dom"
import { Form, Icon, Input, Button, Tooltip, message } from 'antd'
import { Auth } from "aws-amplify"
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"

import LoginBase from './LoginBase'

const queryString = require('query-string');

class ForgotPasswordConfirmForm extends React.Component{

    async onSubmit(e) {

        e.preventDefault()
        this.props.form.validateFieldsAndScroll({first: true}, (err, values) => {
            if (!err) {
                Auth.forgotPasswordSubmit(
                    values.username.toLowerCase().replace(/\s+/g, ''),
                    values.confirmation_code,
                    values.new_password
                )
                .then(data => {
                    message.success("Contraseña cambiada correctamente")
                    this.props.history.push('/login?' + queryString.stringify({email:values.username.toLowerCase().replace(/\s+/g, '')}))
                })
                .catch(error => {
                    switch(error.code){
                        case 'CodeDeliveryDetails':
                            message.error('No pudimos reestablecer tu contraseña. Intenta crear un nuevo usuario',5)
                            break;
                        case 'ExpiredCodeException':
                            message.error('Codigo de verificacion vencido.', 5)
                            break;
                        case 'InvalidPasswordException':
                            message.error('La contraseña debe tener una longitud minima de 8 caracteres entre números y letras')
                            break;
                        case 'CodeMismatchException':
                            message.error('Codigo de verificacion incorrecto')
                            break;
                        default:
                            message.error('No pudimos procesar tu solicitud. Por favor, comunícate con los administradores - codigo: '+error.code,5)
                            break;
                    }
                })
            }
        })
    }

    compareToFirstPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('new_password')) {
            callback('Los passwords no coinciden');
        } else {
            callback();
        }
    };

    validateToNextPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value) {
            form.validateFields(['confirm_password'], { force: true });
        }
        callback();
    };

    render() {

        const { getFieldDecorator } = this.props.form;

        const parsed = queryString.parse(this.props.location.search)
        let email = "email" in parsed ? parsed.email : ""

        if (this.props.login.fechingStatus === true){
            return null;
        }
        else if (this.props.login.calling === false && this.props.login.auth === true ) {
            return <Redirect to="/" />;
        }
        else {
            return (
                <LoginBase title="Cambiar contraseña">
                    <Form
                        onSubmit={(e)=>this.onSubmit(e)}
                        hideRequiredMark={true}
                        style={{margin:"10px"}}
                    >
                        <Form.Item>
                        {
                            getFieldDecorator('username', {
                                rules: [
                                    {
                                        type: 'email',
                                        message: 'Email válido requerido!',
                                    },
                                    {
                                        required: true,
                                        message: 'Email requerido',
                                    },
                                ],
                                initialValue: email
                            })(<Input
                                    prefix={<Icon type="mail" />}
                                    placeholder="E-mail"
                                    suffix={
                                        <Tooltip title="Ingrese su email">
                                            <Icon type="info-circle" />
                                        </Tooltip>
                                    }
                                    autoComplete="username"
                                    //autoFocus={email===""}
                                />)
                        }
                        </Form.Item>
                        <Form.Item>
                        {
                            getFieldDecorator('confirmation_code', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Código de verificación requerido',
                                    },
                                ]
                            })(<Input
                                    prefix={<Icon type="unlock" />}
                                    placeholder="Codigo de verificación"
                                    suffix={
                                        <Tooltip title="Ingrese el código enviado a su mail">
                                            <Icon type="info-circle" />
                                        </Tooltip>
                                    }
                                    autoComplete="off"
                                    //autoFocus={email!==""}
                                />)
                        }
                        </Form.Item>
                        <Form.Item>
                        {
                            getFieldDecorator('new_password', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Contraseña requerida',
                                    },
                                    {
                                        validator: this.validateToNextPassword
                                    }
                                ],
                            })(<Input.Password
                                    prefix={<Icon type="lock" />}
                                    placeholder="Nueva constraseña"
                                    type="password"
                                    autoComplete="new-password"
                                />)
                        }
                        </Form.Item>
                        <Form.Item>
                        {
                            getFieldDecorator('confirm_password', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Confirmacion de contraseña requerida',
                                    },
                                    {
                                        validator: this.compareToFirstPassword
                                    }
                                ],
                            })(<Input.Password
                                    prefix={<Icon type="lock" />}
                                    placeholder="Confirme la contraseña"
                                    type="password"
                                    autoComplete="off"
                                />)
                        }
                        </Form.Item>
                        <Form.Item>
                            <Button
                                onClick={(e)=>this.onSubmit(e)}
                                type="primary"
                                htmlType="submit"
                                loading={this.props.login.calling}
                            >
                                Cambiar contraseña
                            </Button>
                        </Form.Item>
                    </Form>
                </LoginBase>
            )
        }
    }
}

const ForgotPasswordConfirm = Form.create({ name: 'forgot-password-confirm' })(ForgotPasswordConfirmForm);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ForgotPasswordConfirm));
